export const LINKEDIN_API_CONFIG = {
    CLIENT_ID: '77v8ez8521bzq7',
    AUTHORIZATION_URL: 'https://www.linkedin.com/oauth/v2/authorization',
    RESPONSE_TYPE: 'code',
    SCOPE: 'r_dma_portability_3rd_party'
};
